const optimisedDomains = [
  'teamfeedr.com',
  'feedr.co',
  'img.caterdesk-static.com',
  'img.teamfeedr.com',
]
// Only opt into an account's additional host when its build config supplies one.
const configuredImagesUrl = process.env.NEXT_PUBLIC_IMAGES_URL
const configuredImageUrl = configuredImagesUrl ? new URL(configuredImagesUrl) : undefined
const configuredImageHost = configuredImageUrl?.host
if (configuredImageHost) optimisedDomains.push(configuredImageHost)

export interface CloudflareImageOptions {
  src: string
  width: number
  quality?: number
  enabled?: boolean
  relativePaths?: 'transform' | 'preserve'
}

/** Preserves the existing frontend domain matching and URL formatting. */
export function getCloudflareImageUrl(options: CloudflareImageOptions): string {
  const { src, width, quality, enabled = true, relativePaths = 'transform' } = options
  if (!enabled) return src

  const params = ['format=auto', `width=${Math.min(width, 1500)}`]
  if (quality) params.push(`quality=${quality}`)
  const paramsString = params.join(',')

  if (src.startsWith('https://')) {
    if (
      !optimisedDomains.some((domain) =>
        domain === configuredImageHost
          ? src.startsWith(`${configuredImageUrl?.origin}/`)
          : src.includes(domain),
      )
    )
      return src
    const url = new URL(src)
    url.pathname = `/cdn-cgi/image/${paramsString}${url.pathname}`
    return url.toString()
  }

  if (relativePaths === 'preserve') return src
  const normalizedSrc = src.startsWith('/') ? src.slice(1) : src
  return `/cdn-cgi/image/${paramsString}/${normalizedSrc}`
}
